import { createReducer } from "@reduxjs/toolkit";
import { STORE_LOADING, STORE_ERROR, STORE_LIST } from "../actions/types";

const initialState = {
  error: "",
  loading: false,
  data: [],
};

const storeReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(STORE_LOADING, (state) => {
      state.loading = true;
    })
    .addCase(STORE_ERROR, (state, { payload }) => {
      state.error = payload;
    })
    .addCase(STORE_LIST, (state, { payload }) => {
      state.data = payload;
      state.loading = false;
    });
});

export default storeReducer;
